import { Routes } from "@routes";
import { ExportTypeEnum } from "@models/ExportTypeEnum";
import { ID, ReportFileExtension } from "@models";
import { iSearchResultsItem, ItemTypeEnum, SearchResults } from "@models/SearchResults";
import { SearchAction } from "./SearchResultItemActions";

export const createFoodProfileActions = (item: iSearchResultsItem): SearchAction[] => [
    {type: 'link', name: 'Trend', to: SearchResults.getItemLink(item, ItemTypeEnum.FoodProfile)},
    ...(item.isFoodProfile ? [{
        type: 'link' as const,
        name: 'Profile',
        to: `${Routes.foodProfile}?id=${item.id}&name=${encodeURIComponent(item.name)}`,
    }] : []),
];

export const createSummaryReportActions = (
    item: iSearchResultsItem,
    downloadFn: (reportId: ID, format: ExportTypeEnum) => void
): SearchAction[] => [
    {type: 'button', name: 'PDF', onClick: () => downloadFn(item.id, ExportTypeEnum.Pdf)},
    {type: 'button', name: 'PPT', onClick: () => downloadFn(item.id, ExportTypeEnum.Ppt)},
];

export const createCategoryReportActions = (
    item: iSearchResultsItem,
    downloadFn: (reportId: ID, format: ReportFileExtension) => void
): SearchAction[] => [
    {type: 'button', name: 'PDF', onClick: () => downloadFn(item.id, ReportFileExtension.Pdf)},
    {type: 'button', name: 'PPT', onClick: () => downloadFn(item.id, ReportFileExtension.Ppt)},
];
